import React from 'react';
import "./notifications.css";



const NotificationsComponent = (
  {
    notifications,
    removeNotification,
    hover,
    unhover
  }
) => {
  return (
    <div className="notifications" style={{display: notifications.length ? 'flex' : 'none'}}>
      {
        notifications.map((n, i) => (
          <div
            key={n.id}
            className="notifications_notification shadow"
            style={{
              left: n.transition ? '0' : '250px',
            }}
            onClick={() => removeNotification(n.id)}
            onMouseEnter={() => hover(n.id)}
            onMouseLeave={() => unhover(n.id)}
          >
            <div
              className="notifications_notification__header"
              style={{
                backgroundColor: n.hovered ? 'rgb(216, 216, 216)' : 'rgb(216, 216, 216)'
              }}
            >
              <div
                className="notifications_notification__header__header"
                style={{
                  color: n.status === 'Success' ? 'rgb(94, 164, 0)' : 'rgb(236, 61, 61)'
                }}
              >
                <span>{n.status}</span>
              </div>
              <div className="notifications_notification__header__close">
                <i className="fas fa-times" />
              </div>

            </div>
            <div
              className="notifications_notification__body"
              style={{
                backgroundColor: n.hovered ? '#ececec' : 'white'
              }}
            >
              {
                n.message.map((m, i) => (
                  <span key={i} style={{padding: '5px'}}>
                    {m}
                  </span>
                ))
              }
            </div>
          </div>
        ))
      }
    </div>
  )
};

export default NotificationsComponent;





// WEBPACK FOOTER //
// ./src/modules/notifications/notifications-component.js